import { Box, Flex } from "@similarweb/ui-components/foundations";

import { TrafficShare } from "app/components/React/Table/cells";
import { DefaultCellHeader, DefaultCellHeaderRightAlign } from "app/components/React/Table/headerCells";
import type { ITableCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import { translate } from "app/filters/i18nFilter";
import { LocationCell, renderPercentageCellFactory } from "app/pages/sales-intelligence/common-components/table-cells";
import type { GeoBreakdown } from "app/pages/sales-intelligence/modules/company-analysis/types/geo-breakdown";
import createTableColumn from "app/pages/sales-intelligence/pages/home/configuration/table-columns/base/baseColumnFactory";

export const getColumnsConfig = () => [
    createTableColumn({
        field: "country",
        displayName: translate("si.company-analysis.geo-breakdown.card.table.column.country"),
        headerComponent: DefaultCellHeader,
        cellComponent: ({ value }: { value: GeoBreakdown["country"] }) => <LocationCell locationCode={value} />,
    }),
    createTableColumn({
        field: "share",
        displayName: translate("si.company-analysis.geo-breakdown.card.table.column.share"),
        headerComponent: DefaultCellHeader,
        cellComponent: (props: ITableCellProps) => (
            <Box width="100%">
                <TrafficShare
                    {...props}
                    innerColor=""
                />
            </Box>
        ),
    }),
    createTableColumn({
        field: "change",
        displayName: translate("si.company-analysis.geo-breakdown.card.table.column.change"),
        headerComponent: DefaultCellHeaderRightAlign,
        cellComponent: ({ value }: { value: GeoBreakdown["change"] }) => (
            <Flex
                justifyContent="flex-end"
                width="100%"
            >
                {renderPercentageCellFactory(value)}
            </Flex>
        ),
        width: 120,
    }),
];
